import { useRef } from 'react'
import { Appearance, loadStripe, StripeElementLocale } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import i18next from 'i18next'

import { stripeApiKey } from 'config'
import { defaultAppearance } from '../config'

const withStripeElementProvider = (WrappedComponent) => {
  const StripeElement = ({
    clientSecret,
    appearance,
    locale,
    ...props
  }: {
    clientSecret?: string
    appearance?: Appearance
    locale?: string
  } & Record<string, any>) => {
    const stripePromiseRef = useRef(loadStripe(stripeApiKey))
    const options = {
      clientSecret,
      appearance: {
        ...defaultAppearance,
        ...appearance,
      },
      locale: (locale || i18next.language) as StripeElementLocale,
    }

    return (
      <Elements options={options} stripe={stripePromiseRef.current}>
        <WrappedComponent clientSecret={clientSecret} {...props} />
      </Elements>
    )
  }

  return StripeElement
}

export default withStripeElementProvider
